// const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;
// const IMAGE_BASE_URL = "http://65.1.244.239:3001";
// const FOUNDER_IMAGE_URL="http://65.1.244.239:3001/"


// const fetchHome = BASE_URL+"/home";
// const fetchBlogs = BASE_URL+"/blog";
// const fetchAbout = BASE_URL+"/aboutus/";
// const postContactUs = `${BASE_URL}/contactus`;
// const fetchFaqs = `${BASE_URL}/faq`;
// const fetchWhyChooseUs = BASE_URL+"/whychooseus/";


// export {IMAGE_BASE_URL,FOUNDER_IMAGE_URL,fetchFaqs as fetchFaqs, postContactUs as postContactUs,fetchHome as fetchHome,fetchBlogs as fetchBlogs,fetchAbout,fetchWhyChooseUs};

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_BASE_URL = "http://65.1.244.239:3001";
const FOUNDER_IMAGE_URL = `${IMAGE_BASE_URL}/`;

const API_ENDPOINTS = {
  home: `${BASE_URL}/home/`,
  blogs: `${BASE_URL}/blog`,
  about: `${BASE_URL}/aboutus/`,
  contactUs: `${BASE_URL}/contactus`,
  faqs: `${BASE_URL}/faq`,
  whyChooseUs: `${BASE_URL}/whychooseus/`,
  addresses:`${BASE_URL}/auth/user`,
  staticFooterFiles:`${BASE_URL}`,
  orders:`${BASE_URL}/order/`,
  coupons:`${BASE_URL}/coupon/`,
  getAllProducts : `${BASE_URL}/product/getAllActiveProducts`,
  getAllProductsInCategory:`${BASE_URL}/category/getAllProductInCategory/`,
  getProductById:`${BASE_URL}/product/`,
  reviews:`${BASE_URL}/review`,
  cart:`${BASE_URL}/cart/`,
  favourite:`${BASE_URL}/favourite/`,
};

export { BASE_URL, IMAGE_BASE_URL, FOUNDER_IMAGE_URL, API_ENDPOINTS };
